import { defineComponent as _defineComponent } from 'vue'
interface Props {
    message: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsWarning',
  props: {
    message: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})